<template>
  <div
    :class="$style.dateTimeContainer"
  >
    <DatePickerInput
      v-model="eventDate"
      :data-test-id="$testId('datePicker')"
      :errorMessage="errorMessage"
      :label="actionText"
      :minuteIncrement="10"
      positionFixed
      preventPastDates
      showTimePicker
    />
  </div>
</template>

<script>
import {
  DatePickerInput,
} from '@jumpcloud/ui-components';
import { userStateActionType } from 'client/systemusers/constants/SystemUserConstants';
import ActionType from 'client/systemusers/util/ActionType';
import DateUtil from 'client/util/DateUtil';

const { ActivateAction, SuspendAction } = ActionType;
const activateAction = new ActivateAction();
const suspendAction = new SuspendAction();

export default {
  name: 'EventDateTime',

  components: {
    DatePickerInput,
  },

  props: {
    action: {
      type: String,
      default: '',
    },

    value: {
      type: Date,
      default: new Date(),
    },
  },

  data() {
    return {
      errorMessage: '',
    };
  },

  computed: {
    actionText() {
      const title = this.action === userStateActionType.activate
        ? activateAction.descriptionTitle
        : suspendAction.descriptionTitle;

      return `${title} Date and Time`;
    },

    eventDate: {
      get() {
        // Validate initial value so that the error message is always
        // displayed for invalid dates
        this.checkForInvalidDate(this.value);
        return this.value;
      },
      set(newValue) {
        this.checkForInvalidDate(newValue);
        this.$emit('input', newValue);
      },
    },
  },

  methods: {
    /**
     * Due to the implementation of Date/Time picker, we have to do
     * a manual valdation instead of using vee-validte, in order to
     * check if the user has cleared out the field completely.
     */
    checkForInvalidDate(newValue) {
      let message = '';
      let isDateInvalid = false;

      const now = new Date();
      const minimumDate = DateUtil.add(now, 1, 'hours').toDate();

      // If the admin clears out the field, the input returns null
      if (newValue === null) {
        message = 'Date and time are required';
        isDateInvalid = true;
      } else if (newValue < minimumDate) {
        message = 'Select a date and time at least one hour in the future';
        isDateInvalid = true;
      }

      this.$emit('dateIsInvalid', isDateInvalid);
      this.errorMessage = message;
    },
  },

};
</script>

<style module scoped>
.dateTimeContainer {
  padding-bottom: var(--jc-spacer-small);
  padding-top: var(--jc-spacer-small);
  width: max-content;
}
</style>
